module.exports = __webpack_public_path__ + "static/media/border-none.5538f2c9.svg";